<template>
    <div class="flex" :class="getStyle()" v-click-outside="hide">
        <a class="flex items-center justify-center ph3 pointer" style="min-width:80px" @click="toggle">
            <slot name="item"></slot>
        </a>
        <div class="absolute bg-white black" :class="{ 'right-0' : !alignLeft, 'left-0' : alignLeft }" style="top:80px;width:400px;max-width:100vw;" v-if="menuVisible">
            <slot name="menu"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        alignLeft: {
            default: true,
            type: Boolean,
            required: false
        },
        positionRelative: {
            default: true,
            type: Boolean,
            required: false
        },
        colorstyle: {
            type: String,
            required: false
        },
        menuVisible: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    methods: {
        toggle() {
            this.$emit('menuChanged', !this.menuVisible);
        },
        hide() {
            this.$emit('menuChanged', false);
        },
        getStyle() {
            return {
                'bg-white black': this.menuVisible,
                'bg-yellow black':
                    !this.menuVisible && this.colorstyle === 'login',
                'white hover-bg-near-black':
                    !this.menuVisible && this.colorstyle !== 'login',
                relative: this.positionRelative
            };
        }
    },
    watch: {
        $route() {
            this.hide();
        }
    }
};
</script>
